import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/logos/Logo_Bouwrisk.svg",
    width: "70%"
  })
], -1)
const _hoisted_3 = { class: "navigation" }

import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { FileOutlined, LogoutOutlined } from '@ant-design/icons-vue'
import { authStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopNavigation',
  setup(__props) {

const selectedKeys = ref<string[]>([])
const route = useRoute()
const router = useRouter()

watch(() => route.name, () => {
  setActiveRoute()
})

onMounted(() => {
  setActiveRoute()
})

function setActiveRoute () : void {
  if (typeof route.name === 'string') {
    switch (route.name) {
      default:
        selectedKeys.value = [route.name]
        break
    }
  }
}

function navigateTo (navItem:{ key:string }) : void {
  if (route.name !== navItem.key && navItem.key !== 'Logout') {
    const keyboard = window.event as KeyboardEvent
    if (keyboard.ctrlKey) {
      const route = router.resolve({ name: navItem.key })
      window.open(route.href, '_blank')
    } else {
      router.push({ name: navItem.key })
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_menu, {
        class: "desktop-navigation",
        mode: "inline",
        selectedKeys: selectedKeys.value,
        "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
        onClick: navigateTo
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu_item, { key: "Dashboard" }, {
            icon: _withCtx(() => [
              _createVNode(_unref(FileOutlined))
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Mijn bestanden ")
            ]),
            _: 1
          }),
          _createVNode(_component_a_menu_item, {
            key: "Logout",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(authStore)().logout()), ["stop"]))
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(LogoutOutlined))
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Uitloggen ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["selectedKeys"])
    ])
  ]))
}
}

})